import { getConfig } from './config';

export async function createWidgetSession(): Promise<{ sessionId: string }> {
  const { apiUrl, siteKey } = getConfig();
  const res = await fetch(`${apiUrl}widget/session`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'x-api-key': siteKey,
    },
    // Where the App Clip returns the visitor once verified (dropped server-side unless same-origin).
    body: JSON.stringify({ returnUrl: location.href }),
  });

  if (!res.ok) {
    const data = await res.json().catch(() => ({}));
    throw new Error(data.error || 'Failed to create widget session');
  }

  return res.json();
}
